"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

import { BusinessForm } from "./BusinessForm";

interface BusinessFormModalProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  onSuccess?: (businessId: string) => void;
  trigger?: React.ReactNode;
  title?: string;
  description?: string;
}

export function BusinessFormModal({
  open,
  onOpenChange,
  onSuccess,
  trigger,
  title = "Create a business",
  description,
}: BusinessFormModalProps) {
  const handleSuccess = (businessId: string) => {
    onSuccess?.(businessId);
    onOpenChange?.(false);
  };

  const handleCancel = () => {
    onOpenChange?.(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <BusinessForm onSuccess={handleSuccess} onCancel={handleCancel} />
      </DialogContent>
    </Dialog>
  );
}
